import { createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import apiInstance from "../../config/api";


function blobUrlToFile(blobUrl, filename) {
    return fetch(blobUrl)
        .then(response => response.blob())
        .then(blob => new File([blob], filename, { type: blob.type }));
}

function formatUserData(data) {
    const formattedData = {
        userId: data[0].user.userId,
        firstName: "My",
        lastName: "Stories",
        profilePhoto: data[0].user.profilePhoto,
        story: []
    };

    data.forEach(obj => {
        const { user, userId, ...rest } = obj;
        formattedData.story.unshift(rest); // Add the object to the beginning of the array
    });

    return formattedData;
}

export const postUserStory = createAsyncThunk('stories/postUserStory', async ({ file, backgroundColor, caption, loading }) => {
    try {
        const formData = new FormData();

        if (file) { 
            const processedImage = await blobUrlToFile(file, 'new_story.png');
            formData.append('image', processedImage, processedImage.name)
        }
        formData.append('backgroundColor', backgroundColor);
        formData.append('caption', caption);

        const request = await apiInstance.post('/stories/api/profile', formData)
        const response = request.data
        if (response.status === 'success') {
            toast.dismiss(loading)
            toast.success("Story shared successfully!")
            return 
        }
        else {
            throw new Error(response.message)
        }
    } catch (error) {
        toast.dismiss(loading)
        toast.error("unable to share story try again later")
        throw new Error(error.message)
    }
}
);

export const getMyStory = createAsyncThunk('stories/my-stories', async () => {
    try {
        const request = await apiInstance.get('/stories/api')
        const response = request.data
        if (response.message === "story retrieved successfully") {
            const formattedData = formatUserData(response.post)
            return formattedData
        } else {
            throw new Error(response.message)
        }
    }
    catch (error) {
        throw new Error(error.message)
    }
})

export const getFriendsStory = createAsyncThunk('story/get-friends-story', async (userId) => {
    try {
        const request = await apiInstance.get('/stories/api/friends-stories')
        const response = request.data
        // console.log('friends pics; ', response.friendStories[0].profilePhoto)
        if (response.status === 'success') {
            return response.friendStories
        } else {
            throw new Error(response.message)
        }
    }
    catch (error) {
        console.log('story error; ', error.message)
        throw new Error(error.message)
    }
})

export const deleteStory = createAsyncThunk('story/delete-story', async ({ postId, userIndex, storyIndex }) => {
    try {
        const request = await apiInstance.delete(`/stories/api/uploads/single/${postId}`)
        const response = request.data
        if (response.status === 'success') {
            return { postId, userIndex, storyIndex }
        } else {
            throw new Error(response.message)
        }
    }
    catch (error) {
        throw new Error(error.message)
    }
})